<nav [class.close]="sidebarService.isClosed" class="sidebar dark-background">
  <header>
    <div class="image-text">
      <span
        [ngClass]="{ 'logo-small': sidebarService.isClosed }"
        class="image sidebar-header-clickable"
        (click)="onLogoClick()"
        title="Chi ha costruito Diakonix"
        role="button"
        tabindex="0"
        (keydown.enter)="onLogoClick()"
        (keydown.space)="onLogoClick(); $event.preventDefault()"
      >
        <img src="assets/icons/logo-diakonix-black.png" alt="logo" />
      </span>
      <div class="text logo-text">
        <h2 class="name">Diakonix</h2>
        <h5
          class="version-name sidebar-header-clickable"
          (click)="onVersionClick()"
          title="Vedi roadmap e cronologia release"
          role="button"
          tabindex="0"
          (keydown.enter)="onVersionClick()"
          (keydown.space)="onVersionClick(); $event.preventDefault()"
        >v{{ desktopVersion }}</h5>
        <!--
          Data di rilascio (build date): visibile SEMPRE, anche in prod
          (richiesta 2026-07-08). Serve per tracciare quale build gira
          su quale ambiente.
        -->
        <span class="version-date">{{ desktopBuildDate }}</span>
        @if (showDebugVersion) {
          <span class="version-meta version-branch">{{ desktopBranch }}</span>
          <span class="version-meta version-commit">{{ desktopCommit }}</span>
        }
      </div>
    </div>
    <i class="bx bx-chevron-right toggle" (click)="toggleSidenav()"></i>
    <section>
      <div
        class="main-content"
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: 10px;
          margin-bottom: -20px;
          padding: 4px;
          color: #fff;
          background: #017efb;
          border-radius: 8px;
          cursor: pointer;
          box-shadow: 0px 5px 6px 0px rgba(255, 255, 255, 0.75);
        "
      >
        <div class="main-content">
          @if (authServ.isUser.value) {
            <div class="accountName" (click)="goToAccDetails()">
              {{
                !sidebarService.isClosed
                  ? account?.ac_first_name + " " + account?.ac_last_name
                  : account?.ac_first_name?.substring(0, 1) +
                    " " +
                    account?.ac_last_name?.substring(0, 1)
              }}
            </div>
          }
        </div>
      </div>
    </section>
  </header>

  <div class="menu-bar">
    @if (
      authServ.permissionUsed.value == helpers.PermisionAdmin ||
      authServ.permissionUsed.value == helpers.PermisionSuperAdmin
    ) {
      <div class="menu">
        @for (section of filteredSections; track section.key) {
          <div class="accordion-section" [ngClass]="[section.colorClass, section.open ? 'open' : '']">
            <div class="accordion-header" (click)="toggle(section)">

  <i class="bx section-icon" [ngClass]="section.icon"></i>

  @if (!sidebarService.isClosed) {
    <span class="section-title">{{ section.label }}</span>
  }

  @if (!sidebarService.isClosed) {
    <i class="bx" [ngClass]="section.open ? 'bx-chevron-down' : 'bx-chevron-right'"></i>
  }

</div>

            <ul class="menu-links accordion-body" [class.open]="section.open">
              @for (item of section.items; track item.label) {
                <li class="nav-link" routerLinkActive="active">
                  @if (item.type === 'link' && item.route) {
                    <a [routerLink]="item.route">
                      <i class="bx item-icon" [ngClass]="item.icon"></i>
                      <span class="text nav-text">{{ item.label }}</span>
                    </a>
                  }
                  @else if (item.type === 'theme-toggle') {
                    <!--
                      Toggle tema light/dark — re-abilitato in v2.14.0
                      (Sprint 2 Track A F4). Il click delega a
                      `ThemeService.toggle()` che gestisce flip,
                      body class, e localStorage. `isDark` e `theme`
                      sono getter derivati dal service — CD reattivo
                      senza subscribe manuale.
                    -->
                    <div class="theme-toggle">
                      <i class="bx icon" [ngClass]="item.icon"></i>
                      <span class="text nav-text">{{ theme }}</span>
                      <input
                        type="checkbox"
                        [checked]="isDark"
                        (change)="toggleDarkMode()"
                      />
                    </div>
                  }
                  @else {
                    <div class="disabled-link">
                      <i class="bx icon" [ngClass]="item.icon"></i>
                      <span class="text nav-text">{{ item.label }}</span>
                    </div>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>

      <div class="sidebar-footer">
        <div class="nav-logout" (click)="authServ.logout()">
          <i class="bx bx-log-out icon"></i>
          <span class="text nav-text">Logout</span>
        </div>
      </div>
    } 
  </div>
</nav>

<!--
  v2.14.2: rimosso overlay `<app-gestione-account-dettagli>` — era
  dead code (component rimosso in v2.3.0, tag zombie da 4+ anni).
  Il click sul nome utente ora naviga a /accounts?openAccountId=<id>
  che apre il modale "view" nella pagina Account Diakonix (single-page
  restyle di v2.3.0).
-->
